import { render, staticRenderFns } from "./SignaturePendingBanner.vue?vue&type=template&id=803b48ac&scoped=true"
import script from "./SignaturePendingBanner.vue?vue&type=script&lang=js"
export * from "./SignaturePendingBanner.vue?vue&type=script&lang=js"
import style0 from "./SignaturePendingBanner.vue?vue&type=style&index=0&id=803b48ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803b48ac",
  null
  
)

export default component.exports